import axios from "axios";
import { parseCookies, setCookie } from "nookies";

export const apiBookingManager = axios.create({
  baseURL: import.meta.env.VITE_BOOKING_MANAGER,
  headers: {
    "auth-token": parseCookies()["backoffice_token"],
    Authorization: `Bearer ${parseCookies()["backoffice_token"]}`,
  },
});

apiBookingManager.interceptors.response.use((response) => {
  if (response.data.auth_token) {
    apiBookingManager.defaults.headers["auth-token"] = response.data.auth_token;
    setCookie(null, "backoffice_token", response.data.auth_token, {
      path: "/",
      domain: "woba.com.br",
    });
  }

  return response;
});
